import PropTypes from "prop-types";
import React from "react";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/zithas-logo.png";
import ConfigUrl from "../../config"

const Sidebar = props => {
  const path = useLocation();
  return (
    <React.Fragment>
      <div className="vertical-menu" id="vertical-menu">
        <div className="d-lg-flex d-md-none navbar-brand-box justify-content-center">
          <Link to={`${ConfigUrl.appurl}welcome${path?.search}`} className="logo logo-dark w-100">
            <span className="logo-sm">
              <img src={logo} alt="" height="50" className="rounded-3 p-1" />
            </span>
            <span className="logo-lg w-100">
              <img src={logo} alt="" height="70" className="object-fit-cover rounded-3 p-1" />
            </span>
          </Link>

          <Link to={`${ConfigUrl.appurl}welcome${path?.search}`} className="logo logo-light">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="19" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};


export default (withRouter(withTranslation()(Sidebar)));
